import * as urls from "utils/contants/urls";

import {
  ActionItem,
  Actions,
  Label,
  LabelAction,
  LabelHeader,
  Table,
  TableBody,
  TableColumn,
  TableHead,
  TableRow
} from "components/shared/CustomComponentsStyle";
import { Col, Row } from "react-bootstrap";
import React, { PureComponent } from "react";
import {
  cancel,
  edit,
  order as orderIcon,
  show,
  statusAlert,
  statusOk,
  statusWait,
  statusOkFill,
  stop,
  trilha
} from "assets/icons/icons";

import BreadCrumb from "components/Layout/breadcrumb";
import { FormattedMessage } from "react-intl";
import Header from "components/Tab/Header";
import Load from "components/Layout/Load/Load";
import Pagination from "components/Pagination";
import PropTypes from "prop-types";
import Tab from "components/Tab";
import { ToolTip } from "components/shared/CustomComponents";
import { YesOrNoDialog } from "components/shared/CustomComponents";
import { connect } from "react-redux";
import { Creators as jobsActions } from "store/ducks/jobs";
import { orderList, buildCode } from "helpers/sharedHelpers";
import { push } from "connected-react-router";

const renderDraftActions = (job, redirectToVacancy, deleteVacancy) => (
  <Actions>
    <ActionItem onClick={() => redirectToVacancy(job.id, true)}>
      {edit()}
      <LabelAction>
        <FormattedMessage id="sharedItems.edit" />
      </LabelAction>
    </ActionItem>
    <ActionItem onClick={() => deleteVacancy(job)}>
      {cancel()}
      <LabelAction>
        <FormattedMessage id="sharedItems.cancel" />
      </LabelAction>
    </ActionItem>
  </Actions>
);

const renderTip = status => {
  switch (status) {
    case 0:
      return (
        <ToolTip
          id="enabled"
          message={<FormattedMessage id="vacancyList.statusEnabledVacancy" />}
        />
      );
    case 1:
      return (
        <ToolTip
          id="awaiting"
          message={<FormattedMessage id="vacancyList.statuswaitingVacancy" />}
        />
      );
    case 2:
      return (
        <ToolTip
          id="canceled"
          message={<FormattedMessage id="vacancyList.statusCanceledVacancy" />}
        />
      );
      case 3:
        return (
          <ToolTip
            id="canceled"
            message={<FormattedMessage id="vacancyList.statusCanceledVacancy" />}
          />
        );
    default:
  }
};

const renderTableItens = (itens, redirectToVacancy, deleteVacancy) =>
  itens.map(job => (
    <TableRow ta="left" key={job.id}>
      <TableColumn>
        {job.status === 0 &&
          statusWait({
            "data-tip": "data-tip",
            "data-for": "awaiting",
            height: "24px",
            width: "24px"
          })}
        {job.status === 1 &&
          statusOk({
            "data-tip": "data-tip",
            "data-for": "enabled",
            height: "24px",
            width: "24px"
          })}
        {job.status === 2 &&
          statusAlert({
            "data-tip": "data-tip",
            "data-for": "canceled",
            height: "24px",
            width: "24px"
          })}
        {job.status === 3 &&
          statusOkFill({
            "data-tip": "data-tip",
            "data-for": "canceled",
            height: "24px",
            width: "24px"
          })}
      </TableColumn>
      <TableColumn onClick={() => redirectToVacancy(job.id, true)}>
        <Label>{buildCode(job.dataCriacao, "VA", job.id)}</Label>
        {renderTip(job.status)}
      </TableColumn>
      <TableColumn onClick={() => redirectToVacancy(job.id, true)}>
        <Label>{job.titulo}</Label>
      </TableColumn>
      <TableColumn onClick={() => redirectToVacancy(job.id, true)}>
        <Label>{job.cargo}</Label>
      </TableColumn>
      <TableColumn onClick={() => redirectToVacancy(job.id, true)}>
        <Label>{job.site}</Label>
      </TableColumn>
      <TableColumn onClick={() => redirectToVacancy(job.id, true)}>
        <Label>{job.usuarioQueCriou}</Label>
      </TableColumn>
      <TableColumn onClick={() => redirectToVacancy(job.id, true)}>
        <Label>{job.tipoSelecao}</Label>
      </TableColumn>
      <TableColumn flexPosition="flex-end">
        {job.status === 0 &&
          renderDraftActions(job, redirectToVacancy, deleteVacancy)}
      </TableColumn>
    </TableRow>
  ));

class JobList extends PureComponent {
  constructor() {
    super();
    this.state = {
      jobs: [],
      typing: false,
      search: "",
      timer: 0,
      focus: 0,
      showDeleteDialog: false,
      columns: [],
      targetVacancy: 0,
      filter: { valor: 0, campo: "status", NumeroPagina: 1 }
    };

    this.requestVacanciesAndSetTab = this.requestVacanciesAndSetTab.bind(this);
    this.deleteVacancy = this.deleteVacancy.bind(this);
  }

  componentDidMount() {
    const { getJobsList } = this.props;
    getJobsList({ valor: 0, campo: "status", NumeroPagina: 1 });
    this.setState({
      columns: [
        {
          name: <FormattedMessage id="vacancyList.draft" />,
          focus: this.state.focus === 0,
          action: this.requestVacanciesAndSetTab,
          filter: { campo: "status", valor: "0", NumeroPagina: 1 }
        },
        {
          name: <FormattedMessage id="vacancyList.open" />,
          focus: this.state.focus === 1,
          action: this.requestVacanciesAndSetTab,
          filter: { campo: "status", valor: "1", NumeroPagina: 1 }
        },
        {
          name: <FormattedMessage id="vacancyList.inProgress" />,
          focus: this.state.focus === 3,
          action: this.requestVacanciesAndSetTab,
          filter: { campo: "status", valor: "3", NumeroPagina: 1 }
        },
        {
          name: <FormattedMessage id="vacancyList.finished" />,
          focus: this.state.focus === 2,
          action: this.requestVacanciesAndSetTab,
          filter: { campo: "status", valor: "2", NumeroPagina: 1 }
        }
      ]
    });
  }

  static getDerivedStateFromProps(nextProps, state) {
    const jobs = nextProps.jobs.jobs;
    if (state.jobs !== jobs) {
      const response = orderList(state.order, undefined, jobs);
      return { ...state, jobs: response.list, order: response.order };
    }
    return null;
  }

  deleteVacancy(job) {
    this.setState({
      showDeleteDialog: !this.state.showDeleteDialog,
      targetVacancy: job
    });
  }

  requestVacanciesAndSetTab = filter => {
    this.props.getJobsList(filter);
    this.setState({ focus: parseInt(filter.valor), filter: filter });
  };

  orderBy = orderBy => {
    const jobsList = this.state.jobs;
    const { order } = this.state;
    let response;
    switch (orderBy) {
      case "code":
        response = orderList("id", order, jobsList);
        this.setState({ jobs: response.list, order: response.order });
        break;
      case "name":
        response = orderList("titulo", order, jobsList);
        this.setState({ jobs: response.list, order: response.order });
        break;
      case "job":
        response = orderList("cargo", order, jobsList);
        this.setState({ jobs: response.list, order: response.order });
        break;
      case "area":
        response = orderList("area", order, jobsList);
        this.setState({ jobs: response.list, order: response.order });
        break;
      case "manager":
        response = orderList("gestor", order, jobsList);
        this.setState({ jobs: response.list, order: response.order });
        break;
      default:
    }
  };

  search = term => {
    if (this.state.timer) {
      clearTimeout(this.state.timer);
    }
    this.setState({
      search: term,
      typing: false,
      timer: setTimeout(() => {
        this.props.getSearchJob({
          valor: term,
          NumeroPagina: this.props.pagination.currentPage
        });
      }, 1000)
    });
  };

  renderIcon(key) {
    const { order } = this.state;
    return orderIcon({
      style: { transform: `rotate(${order !== key ? "0" : "180deg"})` }
    });
  }

  render() {
    const { jobs } = this.props;
    const { pagination } = this.props;
    const { location } = this.props;
    const { redirectToVacancy } = this.props;
    const { getJobsList } = this.props;
    const { deleteJobRequest } = this.props;

    if (jobs.isLoading) return <Load isLoading={jobs.isLoading} />;

    return (
      <React.Fragment>
        <Row style={{ marginLeft: "0px", marginRight: "0px" }}>
          <Col lg={6}>
            <BreadCrumb
              location={location}
              title={<FormattedMessage id="menuTalentBar.vacancy" />}
            />
          </Col>
          <Col style={{ padding: "0px" }} lg={6}>
            <Header search={e => this.search(e.target.value)} />
          </Col>
        </Row>
        <Tab columns={this.state.columns}>
          <Table>
            <TableBody>
              <TableRow noHover noBorder>
                <TableHead />
                <TableHead onClick={() => this.orderBy("code")}>
                  <LabelHeader>
                    <FormattedMessage id="vacancyList.columns.code" />
                  </LabelHeader>
                  {this.renderIcon("id")}
                </TableHead>
                <TableHead onClick={() => this.orderBy("name")}>
                  <LabelHeader>
                    <FormattedMessage id="vacancyList.columns.name" />
                  </LabelHeader>
                  {this.renderIcon("titulo")}
                </TableHead>
                <TableHead onClick={() => this.orderBy("job")}>
                  <LabelHeader>
                    <FormattedMessage id="vacancyList.columns.role" />
                  </LabelHeader>
                  {this.renderIcon("cargo")}
                </TableHead>
                <TableHead onClick={() => this.orderBy("area")}>
                  <LabelHeader>
                    <FormattedMessage id="vacancyList.columns.site" />
                  </LabelHeader>
                  {this.renderIcon("area")}
                </TableHead>
                <TableHead onClick={() => this.orderBy("area")}>
                  <LabelHeader>
                    <FormattedMessage id="vacancyList.columns.owner" />
                  </LabelHeader>
                  {this.renderIcon("area")}
                </TableHead>
                <TableHead onClick={() => this.orderBy("manager")}>
                  <LabelHeader>
                    <FormattedMessage id="vacancyList.columns.selection" />
                  </LabelHeader>
                  {this.renderIcon("gestor")}
                </TableHead>
                <TableHead />
              </TableRow>
              {renderTableItens(
                this.state.jobs,
                redirectToVacancy,
                this.deleteVacancy
              )}
            </TableBody>
          </Table>
          <Pagination getItemsPage={getJobsList} {...pagination} />
        </Tab>
        <YesOrNoDialog
          confirmation={
            <FormattedMessage id={"sharedItems.confirmDeleteVacancy"} />
          }
          question={<FormattedMessage id="sharedItems.deleteVacancy" />}
          cancelAction={() =>
            this.setState({ showDeleteDialog: !this.state.showDeleteDialog })
          }
          confirmAction={() => {
            deleteJobRequest(this.state.targetVacancy.id, this.state.filter);
            this.setState({
              showDeleteDialog: !this.state.showDeleteDialog,
              targetVacancy: null
            });
          }}
          show={this.state.showDeleteDialog}
        />
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  getJobsList: payload => dispatch(jobsActions.jobsRequest(payload)),
  getJobsListClosed: () => dispatch(jobsActions.jobsFinishedRequest()),
  getJobsDraft: page => dispatch(jobsActions.jobsDraftRequest(page)),
  redirectToVacancy: id => dispatch(push(`${urls.VACANCY_EDITAR}${id}`)),
  getSearchJob: term => dispatch(jobsActions.jobsSearchRequest(term)),
  deleteJobRequest: (id, payload) =>
    dispatch(jobsActions.jobsDeleteRequest(id, payload))
});
const mapStateToProps = state => ({
  jobs: state.jobs,
  pagination: state.jobs.pagination
});

JobList.propTypes = {
  jobs: PropTypes.object,
  pagination: PropTypes.object,
  getJobsList: PropTypes.func,
  getJobsDraft: PropTypes.func
};

JobList.defaultProps = {
  jobs: {},
  pagination: {
    currentPage: 1,
    lastPage: 11,
    sizeItens: 256
  },
  getJobsList: () => { },
  getJobsDraft: () => { }
};
export default connect(mapStateToProps, mapDispatchToProps)(JobList);
